module.exports = __webpack_public_path__ + "img/AlBayan2.87a60522.jpg";